<!--  -->
<template>
  <div>
    <div id="cont">
      <div class="cont">
        <div class="cont_l">
          <div class="cont_l_01">
            <div class="cont_l_02">
              <img :src="images.lcw_03">
            </div>
            <div class="cont_l_03">
              <ul class="lit01">
                <li class="lit01_c">
                  <router-link to="/contacten" class="lit01_b">{{text.contact1}}</router-link>
                </li>
              </ul>
            </div>
            <div class="cont_l_04"></div>
          </div>
        </div>
        <div class="cont_r">
          <div class="cont_r_t">
            <div class="cont_r_t01">
              <span>{{text.profile3}}</span>
              <span>：</span>
              <span>{{text.profile4}}</span>
              <span>-</span>
              <span>{{text.contact1}}</span>
            </div>
          </div>
          <div class="cont_r_b">
            <div id="rightdiv">
              <div class="cont_r_b11">
                <p>
                  <br>
                </p>
                <blockquote>
                  <p v-html="text.contact2"></p>
                </blockquote>
              </div>
            </div>
            <div class="clear"></div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: {
        product3: "Aluminum Coil/Aluminum Plate/Aluminum Foil/CanBody",
        product4: "Remelt Lead Ingot/Remelt Zinc Ingot",
        contact1: "CONTACT US",
        contact2:
          "CHINA MATERIAL INTERNATIONAL Co., LTD<br />Address: O-2307,Kuntai International Mansion, Yi No.12, Chaowei street, Chaoyang District, Beijing<br />Zip code: 100020<br />Tel: (010) 5879 7733<br />Fax: (010) 5879 7758<br />E-mail: marcobj@marco-cn.com"
      },
      images: {
        lcw_03: require("../../../assets/img/en/lcw_03.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/contact/contact.vue